import requestManager from "../platformApi/requestManager";
import appHelper from "@/util/appHelper";

export default {

    requestWithdrawal(price, callback) {
        requestManager.request({
            url : 'portal/v2/account/withdrawal',
            method : 'POST',
            data : {
                price : price
            }
        }, (error, result) => {
            if (error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            if (result.errorCode)
            {
                appHelper.showHint(result.msg);
                return;
            }

            callback(result.data);
        })
    },

    loadSalemanInfo (callback) {
        requestManager.request({
            url : 'portal/v2/distribution/salesman/get/info'
        }, (error, result) => {
            if(error)
            {
                appHelper.generalAjaxError(error);
                return;
            }

            callback(result);
        })
        
    }

}
